import React from "react";

/**
 * Soft decorative shapes (blob / ring / dot / bubble / square), animated via
 * `.st-shape` in StartPage.css. `prefix` picks the per-section placement rules.
 */
export default function StartShapes({ prefix, kinds = ["blob", "ring", "dot", "bubble", "square"] }) {
  return (
    <>
      {kinds.map((k) => (
        <div key={k} className={`st-shape st-shape--${k} ${prefix}-shape-${k}`} aria-hidden="true" />
      ))}
    </>
  );
}
